import type { ReviewsLayoutAlignmentAssignment } from '@typings/experiments';
import type { State } from 'types/redux';
import { selectAssignment } from '.';

export const reviewsLayoutAlignmentSelector = (state: State) => {
	const assignment = selectAssignment(state, ['reviewsLayoutAlignment']);

	return (assignment ?? null) as ReviewsLayoutAlignmentAssignment;
};

export const isInReviewsLayoutAlignmentExperiment = (state: State) => {
	const assignment = reviewsLayoutAlignmentSelector(state);

	return assignment === 'aligned-layout';
};
